export enum StatusAtivoMedsusEnum {
  NAO_INFORMADO,
  ATIVO,
  INATIVO,
}

// Mapeamento para exibição amigável
export const StatusAtivoMedsusLabels: Record<StatusAtivoMedsusEnum, string> = {
  [StatusAtivoMedsusEnum.NAO_INFORMADO]: 'Não informado',
  [StatusAtivoMedsusEnum.ATIVO]: 'Ativo',
  [StatusAtivoMedsusEnum.INATIVO]: 'Inativo',
};

// Mapeamento para códigos/slugs (se necessário para URLs, etc.)
export const StatusAtivoMedsusCodes: Record<StatusAtivoMedsusEnum, string> = {
  [StatusAtivoMedsusEnum.NAO_INFORMADO]: 'NI',
  [StatusAtivoMedsusEnum.ATIVO]: 'A',
  [StatusAtivoMedsusEnum.INATIVO]: 'I',
};

export const getStatusAtivoMedsusOptions = () => {
  return Object.values(StatusAtivoMedsusEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as StatusAtivoMedsusEnum,
      label: StatusAtivoMedsusLabels[value as StatusAtivoMedsusEnum],
      code: StatusAtivoMedsusCodes[value as StatusAtivoMedsusEnum],
    }));
};

export const getStatusAtivoMedsusLabel = (
  statusAtivoMedsus: StatusAtivoMedsusEnum,
): string => {
  return StatusAtivoMedsusLabels[statusAtivoMedsus] || 'Status Desconhecido';
};

export const getStatusAtivoMedsusSlug = (
  statusAtivoMedsus: StatusAtivoMedsusEnum,
): string => {
  return StatusAtivoMedsusCodes[statusAtivoMedsus] || 'Desconhecido';
};

export const getStatusAtivoMedsusPorCodigo = (
  code: string,
): StatusAtivoMedsusEnum | undefined => {
  const entry = Object.entries(StatusAtivoMedsusCodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as StatusAtivoMedsusEnum) : undefined;
};

export const getStatusAtivoMedsusSlugPorValue = (
  value: number | string,
): string => {
  const numericValue = typeof value === 'string' ? Number(value) : value;
  return (
    StatusAtivoMedsusCodes[numericValue as StatusAtivoMedsusEnum] ||
    'Desconhecido'
  );
};

export const getStatusAtivoMedsusLabelPorSlug = (slug: string): string => {
  const entry = Object.entries(StatusAtivoMedsusCodes).find(
    ([, value]) => value === slug,
  );
  if (entry) {
    const key = Number(entry[0]) as StatusAtivoMedsusEnum;
    return StatusAtivoMedsusLabels[key] || 'Não informado';
  }
  return 'Não informado';
};
